// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1jwv7","tab":"ProcedureTabs_tab__2vA_t"};